import { Button, InputAdornment, Modal, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import request from '../../../Helpers/API';
import { LoaderScreen } from '../../components/LoaderScreen';
import { FormatMoney } from '../../../Helpers/FormatNumber';

export const ModalModificarTodo = ({ open, handleClose, datos, ObtenerListado, reseteoFiltro }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [formData, setFormData] = useState({
        utilidad: "0",
        margen: "0",
        costo: "0",
        precio_lista: "0"
    });

    const calcularDesdeMargen = (margenDecimal) => {
        if (formData.costo) {
            const costo = parseFloat(formData.costo);
            const precio_lista = costo / (1 - margenDecimal);
            const utilidad = precio_lista - costo;

            setFormData((prev) => ({
                ...prev,
                utilidad: utilidad.toFixed(2),
                precio_lista: precio_lista.toFixed(2),
            }));
        }
    };

    const calcularDesdeUtilidad = (utilidad) => {
        if (formData.costo) {
            const costo = parseFloat(formData.costo);
            const precio_lista = costo + utilidad;
            const margen = (utilidad / precio_lista) * 100; // Convertir a porcentaje

            setFormData((prev) => ({
                ...prev,
                margen: margen.toFixed(2), // Mostrar en porcentaje (ej. 15 en vez de 0.15)
                precio_lista: precio_lista.toFixed(2),
            }));
        }
    };

    const formatWithCommas = (value) => {
        if (!value) return '';
        return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const removeCommas = (value) => {
        return value.replace(/,/g, '');
    };

    // const handleChange = (e) => {
    //     const { id, value } = e.target;
    //     const numericValue = removeCommas(value);

    //     setFormData((prev) => ({ ...prev, [id]: numericValue }));

    //     if (formData.margen > 100) {
    //         Swal.fire("LISTADO DE PRECIOS", "El margen no debe de ser mayor al 100%", "warning");
    //         setFormData({ ...formData, utilidad: 100 })
    //     }
    // };
    const handleChange = (e) => {
        const { id, value } = e.target;

        // Permitir solo números y un punto decimal
        let numericValue = value.replace(/[^0-9.]/g, '');

        // Evitar múltiples puntos decimales
        if ((numericValue.match(/\./g) || []).length > 1) {
            return;
        }

        // Si es "margen", restringir máximo 99
        if (id === "margen") {
            let num = parseFloat(numericValue);

            // Permitir que el usuario escriba el punto al final (ej. "99.")
            if (numericValue === "" || numericValue === ".") {
                numericValue = "";
            } else if (!isNaN(num) && num > 99) {
                numericValue = "99"; // Ajustar a 99 si se excede
            }
        }

        setFormData((prev) => ({ ...prev, [id]: numericValue }));
    };

    const onGuardar = () => {
        if (formData.utilidad !== "0" && formData.margen !== "0") {
            Swal.fire("LISTADO DE PRECIOS", "Debe dejar una opción en 0", "warning");
            return;
        }

        let datosActualizados = []; // Definir fuera de los bloques para que esté disponible después

        if (formData.margen !== "0") {
            datosActualizados = datos.map((item) => {
                const margenDecimal = parseFloat(formData.margen) / 100;
                const precio_lista = parseFloat(item.costo) / (1 - margenDecimal);
                const calcutilidad = (parseFloat(item.costo) / (1 - margenDecimal)) - item.costo;
                return {
                    ...item,
                    margen: formData.margen,
                    utilidad: calcutilidad.toFixed(2),
                    precio_lista: precio_lista.toFixed(2),
                };
            });
        } else {
            datosActualizados = datos.map((item) => {
                const utilidadDecimal = parseFloat(formData.utilidad);
                const precio_lista = parseFloat(item.costo) + utilidadDecimal;
                const calcmargen = (utilidadDecimal * 100) / (item.costo + utilidadDecimal)
                // console.log(precio_lista)
                return {
                    ...item,
                    utilidad: formData.utilidad,
                    margen: calcmargen.toFixed(2),
                    precio_lista: precio_lista.toFixed(2),
                };
            });
        }
        request
            .post("ListadoPreciosProductoAliado/ActualizarTodosPrecio", { datosActualizados: datosActualizados })
            .then(async () => {
                setLoader({ ...loader, mostrar: false });
                handleClose();
                ObtenerListado();
                reseteoFiltro();
                setFormData({
                    ...formData,
                    utilidad: "0",
                    margen: "0",
                    costo: "0",
                    precio_lista: "0"
                })
                await Swal.fire({
                    title: "LISTADO DE PRECIOS",
                    text: "Precio de lista actualizado",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CARGA DE EVIDENCIA", JSON.stringify(error), "error");
            });
    };


    return (
        <Modal open={open}>
            <div className="otros-modal">
                <LoaderScreen loader={loader} />
                <div className="otros-modal-title">
                    <div className="filtro-soy-el-titulo-header">
                        <h3>CAMBIAR UTILIDAD/MARGEN</h3>
                    </div>
                </div>
                <div className="imagen-modal-soy-el-titulo-line">
                    <div className="imagen-modal-soy-el-titulo-line-bl"></div>
                    <div className="imagen-modal-soy-el-titulo-line-circle"></div>
                    <div className="imagen-modal-soy-el-titulo-line-br"></div>
                </div>

                <div>
                    <div className="">
                        <TextField
                            id="utilidad"
                            label="Utilidad"
                            type="text"
                            value={formatWithCommas(formData.utilidad)} // Mostrar comas mientras escribe
                            onChange={handleChange}
                            onKeyUp={(e) => e.target.value = formatWithCommas(e.target.value)} // Mostrar comas mientras el usuario escribe
                            sx={{ mb: 2, width: 540 }}
                        />
                        <TextField
                            id="margen"
                            label="Margen"
                            type="text"
                            value={formatWithCommas(formData.margen)}
                            onChange={handleChange}
                            onKeyUp={(e) => e.target.value = formatWithCommas(e.target.value)}
                            sx={{ mb: 2, width: 540 }}
                        />
                    </div>
                </div>
                <div className="imagen-modal-button-container ">
                    <div className="cerrar-button" onClick={handleClose} style={{ cursor: "pointer" }}>
                        Cerrar
                    </div>
                    <div className="right-buttons">
                        <div className="agregar-button"
                            onClick={
                                () => onGuardar()
                            }
                            style={{ cursor: "pointer" }}>
                            Agregar
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
};